import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ["form", "submit"];

  static values = {
    fields: Array
  };

  connect() {
    this.initializeState();
    this.setupObservers();
  }

  disconnect() {
    this.observedElements.forEach(element => {
      element.removeEventListener("input", this.checkDirtiness.bind(this));
      element.removeEventListener("change", this.checkDirtiness.bind(this));
    });

    this.formTarget.removeEventListener("reset", this.resetForm.bind(this));
  }

  initializeState() {
    this.isDirty = false;
    this.originalButtonData = this.getButtonData();
    this.observedElements = this.getObservedElements();
    this.initialValues = this.captureInitialValues();

    this.removeConfirmationDataFromButton();
  }

  removeConfirmationDataFromButton() {
    delete this.submitTarget.dataset.confirm;
    delete this.submitTarget.dataset.confirmTitle;
    delete this.submitTarget.dataset.confirmAllow;
  }

  getObservedElements() {
    return Array.from(
      this.formTarget.querySelectorAll("input, select, textarea")
    );
  }

  setupObservers() {
    this.formTarget.addEventListener("reset", this.resetForm.bind(this));

    this.observedElements.forEach(element => {
      element.addEventListener("input", this.checkDirtiness.bind(this));
      element.addEventListener("change", this.checkDirtiness.bind(this));
    });
  }

  resetForm() {
    this.isDirty = false;
  }

  getButtonData() {
    return {
      confirm: this.submitTarget.dataset.confirm || null,
      title: this.submitTarget.dataset.confirmTitle || null,
      allow: this.submitTarget.dataset.confirmAllow || null,
    };
  }

  captureInitialValues() {
    return Array.from(this.observedElements).reduce((acc, el) => {
      acc[el.name] = el.value;
      return acc;
    }, {});
  }

  getElementIdentifier(element) {
    return element.name || element.id;
  }

  checkDirtiness(element) {
    const identifier = this.getElementIdentifier(element.target);
    const initialValue = this.initialValues[identifier];
    const currentValue = element.target.value;
    const isDirty = currentValue !== initialValue;

    this.isDirty = isDirty;

    if (this.fieldsValue.includes(identifier)) {
      this.toggleConfirmDialog(isDirty);
    }
  }

  toggleConfirmDialog(isDirty) {
    if (isDirty) {
      this.submitTarget.dataset.confirm = this.originalButtonData.confirm;
      this.submitTarget.dataset.confirmTitle = this.originalButtonData.title;
      this.submitTarget.dataset.confirmAllow = this.originalButtonData.allow;
    } else {
      delete this.submitTarget.dataset.confirm;
      delete this.submitTarget.dataset.confirmTitle;
      delete this.submitTarget.dataset.confirmAllow;
    }
  }
}
